import { QRCodeCanvas } from 'qrcode.react';
import React from 'react';

type QRCodeProps = {
  link: string;
  size?: number;
  downloadFileName?: string;
};

const QR_CODE_ID = 'qrcode-canvas';

export const downloadQRCode = (downloadFileName = 'qrcode') =>
  new Promise<void>((resolve, reject) => {
    const qrCanvas = document.getElementById(QR_CODE_ID) as HTMLCanvasElement | null;

    if (!qrCanvas) {
      return reject(new Error('Failed to download QR code.'));
    }

    qrCanvas.toBlob(blob => {
      if (!blob) {
        return reject(new Error('Failed to download QR code.'));
      }

      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = `${downloadFileName}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      URL.revokeObjectURL(downloadLink.href);
      resolve();
    }, 'image/png');
  });

export const QRCode = ({ link, size }: QRCodeProps) => {
  return <QRCodeCanvas id={QR_CODE_ID} value={link} size={size} />;
};
